import { toCurrencyFormat } from "@lib/utils"
import { useBalanceStore } from "@stores/balanceStore"
import {
    Container,
    BalanceContainer,
    BalanceText,
    EyeContainer
} from "./BalanceDisplay.styles"
import Eye from "@components/Eye/Eye"
import { JIDRCurrencyPng } from "@components/CurrencyIcon/CurrencyIcon"
import { useTranslation } from "react-i18next"

const BalanceDisplay = ({ balance }: { balance: number | any }) => {
    const { showBalance, toggleShowBalance } = useBalanceStore()
    const { t } = useTranslation()
    const notAvailable = typeof balance !== 'number'

    return (
        <Container>
            <BalanceContainer>
                <JIDRCurrencyPng width={24} height={24} />
                <BalanceText $showBalance={showBalance}>
                    {showBalance ? (notAvailable ? t('page.home.notAvailable') : toCurrencyFormat(balance)) : '*****'}
                </BalanceText>
            </BalanceContainer>
            <EyeContainer onClick={toggleShowBalance}>
                <Eye active={showBalance} />
            </EyeContainer>
        </Container>
    )
}

export default BalanceDisplay